export const SELF_ASSESSMENT_REPORT = 'SelfAssessmentReport';
export const GET_SELF_REPORT_TABLE_DATA = `${SELF_ASSESSMENT_REPORT}/getSelfReportAction`;
export const GET_SELF_REPORT_DROP_DOWN = `${SELF_ASSESSMENT_REPORT}/getSelfDropDownAction`;
export const GET_SELF_EXPORT_FILE = `${SELF_ASSESSMENT_REPORT}/getSelfExportFileAction`;
export const GET_EMPLOYEE = `${SELF_ASSESSMENT_REPORT}/getEmployeeAction`;